import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable()
export class NotificationService {

  public url: string;
  constructor(private httpClient: HttpClient) {
    this.url = environment.backend;
  }

  sendClientNotificationToManager(dest, exped) {
    return new Promise ((resolve, reject) => {
      this.httpClient
        .post(this.url + '/mail/client', {'dest': dest, 'exped': exped})
        .subscribe(
          (popin) => {
            resolve(popin);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  sendProspectNotificationToManager(dest, exped) {
    return new Promise ((resolve, reject) => {
      this.httpClient
        .post(this.url + '/mail/prospect', {'dest': dest, 'exped': exped})
        .subscribe(
          (popin) => {
            resolve(popin);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

}
